import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="12"
      viewBox="0 0 18 12"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#5A5B5E" fillRule="nonzero" transform="translate(-1087 -760)">
          <g transform="translate(216 137)">
            <g transform="translate(0 395)">
              <g transform="translate(1 66)">
                <g transform="translate(0 150)">
                  <g transform="translate(861)">
                    <path d="M18 12c-3.44 0-6.558 2.104-8.86 5.522a.874.874 0 000 .952C11.443 21.896 14.56 24 18 24c3.44 0 6.558-2.104 8.86-5.522a.874.874 0 000-.952C24.557 14.104 21.44 12 18 12zm.247 10.225c-2.283.16-4.168-1.944-4.025-4.5.118-2.11 1.646-3.818 3.531-3.95 2.283-.16 4.168 1.944 4.025 4.5-.122 2.105-1.65 3.814-3.531 3.95zm-.114-1.952c-1.23.087-2.247-1.046-2.166-2.421.063-1.137.888-2.055 1.904-2.13 1.23-.086 2.246 1.047 2.165 2.422-.066 1.14-.89 2.06-1.903 2.13z"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Icon;



// WEBPACK FOOTER //
// src/icons/icon_eye.js